(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-full-product-card"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSpicyHero(hero) {
      if (!hero || hero.dataset.spicyHeroInit === 'true') {
        return;
      }
      hero.dataset.spicyHeroInit = 'true';

      // No IntersectionObserver support: just reveal it.
      if (!('IntersectionObserver' in window)) {
        hero.classList.add('is-inview');
        return;
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            entry.target.classList.toggle('is-inview', entry.isIntersecting);
          });
        },
        { threshold: 0.35 }
      );

      observer.observe(hero);
    }

    function initAll() {
      document.querySelectorAll('.spicy-hero').forEach(initSpicyHero);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    // Re-init when re-rendered inside the Shopify theme editor.
    document.addEventListener('shopify:section:load', function (event) {
      initSpicyHero(event.target.querySelector('.spicy-hero'));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
